






import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 4.8.1
 * @changelog 4.8.1 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsNotificationBadge extends Vue {
    @Prop() to!: string;
    @Prop() icon!: string;
}
